export const DEFAULT_EMAIL_ADDRESS = 'doorpakken@nl.abnamro.com';
